import * as React from 'react';
import {
  ArticleComponentDataProps,
  FiniteScrollArticleComponentDataProps,
} from '../../templates/utils/articleComponent.utils';
import { ArticlePageViewEvent } from './ArticlePageViewEvent';
import { createBlockNames } from '../../store/template/postPage/utils/createBlockNames';
import { getCoverType } from '../../templates/templates.utils';

interface FiniteScrollNextArticlesProps {
  articles: Array<FiniteScrollArticleComponentDataProps>;
  articleComponent: React.FunctionComponent<ArticleComponentDataProps>;
}

export const FiniteScrollNextArticles: React.FunctionComponent<FiniteScrollNextArticlesProps> = props => {
  const { articles, articleComponent } = props;
  const [shouldRenderFiniteScrollArticles, setShouldRenderFiniteScrollArticles] = React.useState(false);
  const ArticleComponent = articleComponent;

  const scrollHandler = React.useCallback(() => {
    setShouldRenderFiniteScrollArticles(true);
  }, []);

  React.useEffect(() => {
    if (!shouldRenderFiniteScrollArticles) {
      window.addEventListener('scroll', scrollHandler);
    }
  }, [scrollHandler, shouldRenderFiniteScrollArticles]);

  React.useEffect(() => {
    if (shouldRenderFiniteScrollArticles) {
      window.removeEventListener('scroll', scrollHandler);
    }
  }, [scrollHandler, shouldRenderFiniteScrollArticles]);

  return shouldRenderFiniteScrollArticles
    ? (
      <React.Fragment>
        {articles.map((articleProps, index) => (
          <ArticlePageViewEvent
            key={index}
            articlePageViewParameters={{
              articleId: articleProps.id,
              articleTemplate: createBlockNames(articleProps.body),
              channels: articleProps.feeds,
              articleAuthor: articleProps.ownerName,
              articleTitle: articleProps.title,
              articlePublicationTime: articleProps.createdAtDateFormatted,
              contentTags: articleProps.tags,
              mainMedia: getCoverType(articleProps.cover),
              commercialTags: articleProps.commercialTags,
              articleContentCount: articleProps.articleContentCount,
              articleWordCount: articleProps.articleWordCount,
              ABTestGroups: articleProps.ABTestGroups,
              ownerUsername: articleProps.ownerUsername,
            }}
          >
            <ArticleComponent {...articleProps} />
          </ArticlePageViewEvent>
        ))}
      </React.Fragment>
    )
    : null;
};
